import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

function scrollActiveIntoView() {
  if (typeof document.activeElement.scrollIntoViewIfNeeded === 'function') {
    document.activeElement.scrollIntoViewIfNeeded();
  }
}

/* eslint-disable react/no-multi-comp */
class ScrollAndroidInputsToIntoViewIfNeeded extends PureComponent {
  constructor(props) {
    super(props);

    this.resizeListener = this.resizeListener.bind(this);

    this.scrollRequest = null;
  }

  componentDidMount() {
    if (/Android [4-9]/.test(navigator.appVersion)) {
      window.addEventListener('resize', this.resizeListener);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeListener);

    if (this.scrollRequest) {
      window.cancelAnimationFrame(this.scrollRequest);
      this.scrollRequest = null;
    }
  }

  resizeListener() {
    if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
      this.scrollRequest = window.requestAnimationFrame(scrollActiveIntoView);
    }
  }

  render() { return this.props.children } // eslint-disable-line react/prop-types
}

export default withRouter(ScrollAndroidInputsToIntoViewIfNeeded);
